import { Combobox } from '@globalvisioninc/ui/combobox';
import type { ComboboxOption } from '@globalvisioninc/ui/combobox';

export type OrganizationComboboxOption = ComboboxOption;

export interface OrganizationComboboxProps {
  options: OrganizationComboboxOption[];
  value: string;
  onValueChange: (value: string) => void;
  label: string;
  isLoading?: boolean;
  className?: string;
  /** Portal target for the list panel (e.g. dialog content) so MUI aria-hidden does not trap options. */
  container?: HTMLElement | null;
}

/**
 * Organization search Combobox.
 * Filtering is left to Combobox (label + option value / id via keywords).
 * Search text is uncontrolled so dismiss restores the selected label.
 */
const OrganizationCombobox = ({
  options,
  value,
  onValueChange,
  label,
  isLoading,
  className,
  container,
}: OrganizationComboboxProps) => (
  <Combobox.Root
    className={className}
    options={options}
    value={value}
    onValueChange={onValueChange}
    isLoading={isLoading}
    hasClearButton
    container={container}
  >
    <Combobox.Label>{label}</Combobox.Label>
    <Combobox.Input />
  </Combobox.Root>
);

export default OrganizationCombobox;
